module.exports = __webpack_public_path__ + "img/qrcodeimage.07666746.png";